import store from '@/store';
import S_base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async show() {
    const factoryId = store.state.app.factory.id;
    return await S_base.show({
      url: `factory/${factoryId}/factory_log_backup`,
      params: { factory: factoryId },
    });
  },
  async update(id, data) {
    return await S_base.update({
      modelName: 'factory_log_backup',
      modelId: id,
      data: { factory: store.state.app.factory.id, ...data },
    });
  },
};
